import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * LogoutHandler - Handles manual logout requests
 * Used when authentication fails and user needs to clear session
 */
function LogoutHandler() {
  const { logout, authConfig } = useAuth();

  useEffect(() => {
    // If we have auth config, logout immediately
    if (authConfig) {
      logout();
    }
  }, [authConfig, logout]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      background: 'white'
    }}>
      <img 
        src="/lendport_logo_icon_text.svg" 
        alt="Lendport" 
        style={{ 
          width: '180px', 
          opacity: 0.3,
          filter: 'grayscale(100%)',
          marginBottom: '30px'
        }} 
      />
      <div style={{
        width: '200px',
        height: '2px',
        background: 'linear-gradient(90deg, transparent, #e5e7eb, transparent)',
        marginBottom: '30px',
        animation: 'pulse 1.5s ease-in-out infinite'
      }}></div>
      <h2 style={{ color: '#6b7280', fontWeight: '400', fontSize: '16px' }}>Clearing session...</h2>
      <p style={{ color: '#9ca3af', fontSize: '13px', marginTop: '10px' }}>You'll be redirected to login</p>
    </div>
  );
}

export default LogoutHandler;
